import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import Button, { type ButtonProps } from '@mui/material/Button';

interface Props extends ButtonProps {
    to: string,
}

export default function ReactRouterButtonLink({
    to,
    children,
    ...props
}: Props) {
    return (
        <MuiLink component={ReactRouterLink} to={to}>
            <Button {...props}>{children}</Button>
        </MuiLink>
    );
}
